import type { RouteRecordRaw } from 'vue-router';
import { DEVICE_MANAGEMENT_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const deviceManagementRoutes: RouteRecordRaw = {
  path: '/device-management',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: DEVICE_MANAGEMENT_ROUTE_NAME.DEVICE_MANAGEMENT,
      path: '',
      component: () => import('./DeviceManagement.vue'),
    },
  ],
};
